import axios from '@lib/axios';
import { useMutation, useQueryClient, } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export interface CompanyInputs {
  name: string;
  website: string;
  logo?: string;
  categoryId: string;
  customerServiceUserId: string;
  active?: boolean;
}
// export interface TData {
//   name: string;
//   email: string;
//   role: string;
// }

interface SaveCompanyProps {
  companyId?: string;
	onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useSaveCompany = ({
  companyId,
	onSuccess,
  onError
}: SaveCompanyProps) => {
  const queryClient = useQueryClient();
	const {
		isPending,
		isError,
		error,
		mutate: onSaveCompany,
	} = useMutation({
		mutationFn: async (data: CompanyInputs) => {
      if (companyId) 
        return axios.patch(`/companies/${companyId}`, data);
      return axios.post('/companies', data);
		},
		onSuccess: (data) => {
      if (companyId)
        queryClient.invalidateQueries({ queryKey: ['company', companyId] });
      if (onSuccess)
        onSuccess(data);
    },
    onError
	});

	return { onSaveCompany, isPending, isError, error };
};
